// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2okA1","title":"Images90_title__3c9Ix","images":"Images90_images__3IQvE"};